// frontend/admin-portal/src/routes/domains/catalogRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import { PermissionRoute } from "@fiberhome/shared-ui";

import Products from "../../pages/Products";
import ProductDetail from "../../pages/ProductDetail";
import ImportProducts from "../../pages/ImportProducts";
import Categories from "../../pages/Categories";
import Brands from "../../pages/Brands";
import Customers from "../../pages/Customers";
import CustomerDetail from "../../pages/CustomerDetail";
import CustomerStatement from "../../pages/CustomerStatement";

export default function CatalogRoutes() {
  return (
    <>
      {/* Products */}
      <Route element={<PermissionRoute permission="products.read" />}>
        <Route path="products" element={<Products />} />
        <Route path="products/:id" element={<ProductDetail />} />
      </Route>

      <Route element={<PermissionRoute permission="products.import" />}>
        <Route path="products/import" element={<ImportProducts />} />
      </Route>

      {/* Categories */}
      <Route element={<PermissionRoute permission="categories.read" />}>
        <Route path="categories" element={<Categories />} />
      </Route>

      {/* Brands */}
      <Route element={<PermissionRoute permission="brands.read" />}>
        <Route path="brands" element={<Brands />} />
      </Route>

      {/* Customers — all use customers.read */}
      <Route element={<PermissionRoute permission="customers.read" />}>
        <Route path="customers" element={<Customers />} />
        <Route path="customers/:id" element={<CustomerDetail />} />
        <Route path="customers/:id/statement" element={<CustomerStatement />} />
      </Route>
    </>
  );
}
